import { Component, EventEmitter, Output } from '@angular/core';
import { analytics } from '@app/events/segment/analytics';

@Component({
  selector: 'app-survey-options',
  imports: [],
  templateUrl: './survey-options.component.html',
  styleUrl: './survey-options.component.css'
})
export class SurveyOptionsComponent {
  @Output() startSurveyEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();
  
  startSurveyBtn() {
    analytics.track('Survey Start', { section: 'survey' });
    this.startSurveyEmitter.emit(true);
  }
}
